import React, { useState } from "react";
import { ClickAwayListener, Stack, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import dayjs from "dayjs";

import { HubButton, HubHookFormDatePicker } from "../../components";
import { getDateData } from "../../helpers/dateHelper";
import { usePutAdminQuickUpdateWorkOrder } from "../../hooks/react-query/useWorkOrderData";
import { StyledBox } from "./styles";

const PORTAL_CLASSES = [
  "MuiPickersPopper-root",
  "MuiPopover-root",
  "MuiMenu-root",
];

const isInsidePortal = (target) =>
  PORTAL_CLASSES.some((cls) => target.closest(`.${cls}`));

const ShipDateCell = ({ item }) => {
  const [editing, setEditing] = useState(false);
  const [hovered, setHovered] = useState(false);
  const methods = useForm({ defaultValues: { shipDate: item.shipDate } });
  const { mutate, isLoading } = usePutAdminQuickUpdateWorkOrder();

  const handleChange = (value) => {
    if (!value || value === item.shipDate) {
      setEditing(false);
      return;
    }
    const payload = {
      id: item.workOrder,
      shipDate: dayjs(value).utc().toISOString(),
    };
    const options = { onSettled: () => setEditing(false) };
    mutate(payload, options);
  };

  const handleClickAway = (event) => {
    if (isInsidePortal(event.target)) return;
    setEditing(false);
  };

  if (editing) {
    return (
      <ClickAwayListener onClickAway={handleClickAway}>
        <StyledBox onClick={(e) => e.stopPropagation()}>
          <FormProvider {...methods}>
            <HubHookFormDatePicker
              name="shipDate"
              defaultValue={item.shipDate}
              onChange={handleChange}
              disabled={isLoading}
              slotProps={{
                textField: { size: "small", autoFocus: true },
              }}
            />
          </FormProvider>
        </StyledBox>
      </ClickAwayListener>
    );
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="10px"
      width="200px"
      height="18px"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        e.stopPropagation();
        setEditing(true);
      }}
    >
      <Typography variant="caption" fontSize={11}>
        {item.shipDate
          ? getDateData({ startDate: item.shipDate, includeYear: true })
          : "—"}
      </Typography>
      <HubButton
        variant="text"
        icon="Edit"
        iconProps={{ size: "12px" }}
        sx={{ color: hovered ? "hubColors.greyDark" : "hubColors.white" }}
        size="xsmall"
      />
    </Stack>
  );
};

export default ShipDateCell;
